import errorMessage_zh from './errorMessage_zh';

const locale_zh = {
	Internet_banking: '网上银行',
	hsbc_logo: '汇丰香港 银行服务',
	timeout_title: '您本次登录即将完结，要保持登录吗？',
	timeout_quit: '登出',
	timeout_continue: '保持登录',
	homeTitle: '理财管理系统',
	footer_copyright: "© 版权所有。香港上海汇丰银行有限公司 2002-{endYear}。不得转载。",
	design_for_hk: "本网站为在香港使用而设计。",
	cross_border: "<a href='https://www.hsbc.com.hk/zh-cn/digital/cross-border-banking/' target='_blank'>跨境披露声明</a>",
	customer_landing: '欢迎您回来, ',
	hello : '欢迎光临, QY!',
	superHello : '欢迎光临, { someone } !',
	Collapse_Menu: '收起菜单',

	...errorMessage_zh
};

export default locale_zh;
